export const models = [
  
  {
    name: "Catapult",
    slug: "catapult",
    rank: 1,
    description: "A model of the catapult from the battletech univurse.",
    images: [
      "/models/Catapult/Catapultimage2.png",
      "/models/ratmech/ratmech-front.png",
      "/models/ratmech/ratmech-front.png"
    ],
    photos: [
      { type: "image", src: "/models/Catapult/Catapultimage2.png" },
    ],
    modelFile: "/models/ratmech/ratmech.glb",
    details: `
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
      Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
      Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
    `,
    softwareUsed: ["Blender", "Substance Painter"],
    challenges: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elitn",
      "t fugit, sed quia consequuntur magni dol",
      "dolore magnam aliquam quaerat"
    ],
    usageExamples: [
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Placed in a mock FPS game scene to demonstrate scale and lighting."
      },
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Dynamic pose to test rig and edge flow during extreme deformation."
      }
    ]
  },

  {
    name: "Night Drive",
    slug: "nightdrive",
    rank: 7,
    description: "A poster made for a driving school as an advertisement.",
    images: [
      "/models/NightDrive/drrrrrd.png",
      "/models/ratmech/ratmech-front.png",
      "/models/ratmech/ratmech-front.png"
    ],
    photos: [
      { type: "image", src: "/models/NightDrive/drrrrrd.png" },
    ],
    modelFile: "/models/ratmech/ratmech.glb",
    details: `
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
      Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
      Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
    `,
    softwareUsed: ["Blender", "Substance Painter"],
    challenges: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elitn",
      "t fugit, sed quia consequuntur magni dol",
      "dolore magnam aliquam quaerat"
    ],
    usageExamples: [
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Placed in a mock FPS game scene to demonstrate scale and lighting."
      },
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Dynamic pose to test rig and edge flow during extreme deformation."
      }
    ]
  },

  {
    name: "Scifi Soldier",
    slug: "ratmech",
    rank: 4,
    description: "A model of an armored woman, with many weapons.",
    images: [
      "/models/ScifiSoldier/dude.png",
      "/models/ratmech/ratmech-front.png",
      "/models/ratmech/ratmech-front.png"
    ],
    photos: [
      { type: "image", src: "/models/ScifiSoldier/dude.png" },
    ],
    modelFile: "/models/ratmech/ratmech.glb",
    details: `
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
      Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
      Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
    `,
    softwareUsed: ["Blender", "Substance Painter"],
    challenges: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elitn",
      "t fugit, sed quia consequuntur magni dol",
      "dolore magnam aliquam quaerat"
    ],
    usageExamples: [
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Placed in a mock FPS game scene to demonstrate scale and lighting."
      },
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Dynamic pose to test rig and edge flow during extreme deformation."
      }
    ]
  },

  {
    name: "First Model",
    slug: "firstmodel",
    rank: 3,
    description: "An old mech made durring my years at noroff as a test piece.",
    images: [
      "/models/FirstModel/OldMech.png",
      "/models/ratmech/ratmech-front.png",
      "/models/ratmech/ratmech-front.png"
    ],
    photos: [
      { type: "image", src: "/models/FirstModel/OldMech.png" },
      { type: "image", src: "/models/FirstModel/OldMech.png" },
      { type: "youtube", src: "https://www.youtube.com/watch?v=GwF9EjnsNUQ", thumbnail: "/custom-thumbnail.jpg" }

    ],
    modelFile: "/models/ratmech/ratmech.glb",
    details: `
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
      Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
      Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
    `,
    softwareUsed: ["Blender", "Substance Painter"],
    challenges: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elitn",
      "t fugit, sed quia consequuntur magni dol",
      "dolore magnam aliquam quaerat"
    ],
    usageExamples: [
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Placed in a mock FPS game scene to demonstrate scale and lighting."
      },
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Dynamic pose to test rig and edge flow during extreme deformation."
      }
    ]
  },

  {
    name: "MadCat",
    slug: "madcat",
    rank: 2,
    description: "A Mech made in the retro style of early PS1 grahpics!",
    images: [
      "/models/MadCat/RetroMech.png",
      "/models/ratmech/ratmech-front.png",
      "/models/ratmech/ratmech-front.png"
    ],
    photos: [
      { type: "image", src: "/models/MadCat/RetroMech.png" },
    ],

    modelFile: "/models/ratmech/ratmech.glb",
    details: `
      RatMech is a stylized combat mech inspired by rodent anatomy and cyberpunk themes.
      It features glowing eyes, a flexible tail, and modular armor. Built using Blender and textured in Substance Painter.
    `,
    softwareUsed: ["Blender", "Substance Painter"],
    challenges: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elitn",
      "t fugit, sed quia consequuntur magni dol",
      "dolore magnam aliquam quaerat"
    ],
    usageExamples: [
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Placed in a mock FPS game scene to demonstrate scale and lighting."
      },
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Dynamic pose to test rig and edge flow during extreme deformation."
      }
    ]
  },
  
  {
    name: "War Mech",
    slug: "warmech",
    rank: 2,
    description: "A mech made in the retro style of early ps1 grahpics!",
    images: [
      "/models/WarMech/War Mech.png",
      "/models/ratmech/ratmech-front.png",
      "/models/ratmech/ratmech-front.png"
    ],
    photos: [
      { type: "image", src: "/models/WarMech/War Mech.png" },
    ],
    modelFile: "/models/ratmech/ratmech.glb",
    details: `
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
      Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
      Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
    `,
    softwareUsed: ["Blender", "Substance Painter"],
    challenges: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elitn",
      "t fugit, sed quia consequuntur magni dol",
      "dolore magnam aliquam quaerat"
    ],
    usageExamples: [
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Placed in a mock FPS game scene to demonstrate scale and lighting."
      },
      {
        title: "Lorem ipsum dolor",
        image: "/models/ratmech/ratmech-front.png",
        description: "Dynamic pose to test rig and edge flow during extreme deformation."
      }
    ]
  },
  
  
];